module.exports = __webpack_public_path__ + "static/media/repartition.c7ded1e1.svg";